import React, {Component} from "react";
import './SideBar.css';
import {Link} from "react-router-dom";
import {Collapse} from 'react-bootstrap';
import {FormattedMessage} from "react-intl";
import axios from "axios";
import {BASE_URL, RESOURCE_BASE_URL} from "../../../../../configuration";
import InitialAdminState from "../../InitialAdminState";
import $ from "jquery";

class MenuItem extends Component {
    constructor(props) {
        super(props);
        this.colorChange = this.colorChange.bind(this)
    }

    colorChange = (event) => {

        if (window.innerWidth < 993) {
            $('.navbar-toggle').click();
            $('.sidebar-content').css('width', '100%')
            $('.sidebar-content').css('display', 'unset')
        }

        let classElements = document.getElementsByClassName("menu-item");

        for (let i = 0; i < classElements.length; i++) {
            classElements[i].classList.remove("blueDiv");
        }

        if (document.getElementById(event) !== null) {
            let element = document.getElementById(event);
            element.classList.add('blueDiv')
        }
    };

    componentDidMount() {

        let elm = document.getElementById("1a");

        if(elm !== null && window.location.href === BASE_URL + 'admin/inquiries/viewAll'){
            elm.classList.add("blueDiv");
        }

        $('.menu-item-container').click(function () {
            // $('.admin-content').addClass('content-block-absolute')
            // $('.sidebar-content').addClass('sideBar-block-absolute')

        });

    }

    render() {

        return (
            <div className="link-text-color menu-item-container">
                <Link to={this.props.data.link} onClick={(event) => this.colorChange(this.props.data.id)}>
                    <div
                        className='menu-item'
                        id={this.props.data.id}>
                        {this.props.data.text}</div>
                </Link>
            </div>
        )
    }
}

class MenuItemContainer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return this.props.isOpen ?
            this.props.menuItems.map((mi) => {
                return <MenuItem key={mi.id} data={mi}/>;
            }) : null
    }

}

class MainMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.data.id,
            notification: 0,
            complaintNotification: 0,
        };

        this.toggleMenuItemContainer = this.toggleMenuItemContainer.bind(this);
        this.getNewInquiryCount = this.getNewInquiryCount.bind(this);
        this.getNewComplaintCount = this.getNewComplaintCount.bind(this);
    }

    toggleMenuItemContainer = () => {
        this.props.setOpenMenu(this.state.id);
    };

    getNewInquiryCount = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/admin/new-inquiry/count', axiosConfig)
            .then((res) => {
                // console.log("NEW INQUIRY COUNT ==== > ", res.data);
                this.setState({
                    notification: res.data
                })
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                console.log("Token invalid");
                // localStorage.clear();
                // window.location.replace(BASE_URL + "login");
            });
    };

    getNewComplaintCount = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/quality-complaint/admin/count/new', axiosConfig)
            .then((res) => {
                // console.log("NEW COMPLAINTS COUNT ==== > ", res.data);
                this.setState({
                    complaintNotification: res.data
                })
            })
            .catch((err) => {
                console.log("[API] ERROR: complaints count ", err);
            });
    };

    componentDidMount() {
        this.getNewInquiryCount();
        this.getNewComplaintCount();
    }

    render() {
        // console.log("ONLINE USERS======> ", this.props.onlineChatUsers.size);
        return (
            <div className="main-menu-text-color main-menu-container">
                {this.props.data.isOpen ?
                    <div className="main-menu main-menu-active" onClick={this.toggleMenuItemContainer}>
                        <i className="fa fa-share"> </i> {this.props.data.text}
                        {this.props.data.id === 1 && this.state.notification !== 0 ?
                            <sup className="badge cart-item-count-badge">
                                {this.state.notification}
                            </sup> : ""}
                        {this.props.data.id === 6 && this.state.complaintNotification !== 0 ?
                            <sup className="badge cart-item-count-badge">
                                {this.state.complaintNotification}
                            </sup> : ""}
                        {this.props.data.id === 5 ?
                            <sup className="badge cart-item-count-badge">
                                {this.props.onlineChatUsers}
                            </sup> : ""}

                    </div> :
                    <div className="main-menu" onClick={this.toggleMenuItemContainer}>
                        <i className="fa fa-share"> </i> {this.props.data.text}
                        {this.props.data.id === 1 && this.state.notification !== 0 ?
                            <sup className="badge cart-item-count-badge">
                                {this.state.notification}
                            </sup> : ""}

                        {this.props.data.id === 6 && this.state.complaintNotification !== 0 ?
                            <sup className="badge cart-item-count-badge">
                                {this.state.complaintNotification}
                            </sup> : ""}
                        {this.props.data.id === 5 ?
                            <sup className="badge cart-item-count-badge">
                                {this.props.onlineChatUsers}
                            </sup> : ""}
                    </div>}
                <MenuItemContainer isOpen={this.props.data.isOpen} menuItems={this.props.data.menuItems}/>
            </div>
        )
    }

}

export default class SideBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menus: [
                {
                    id: 1,
                    isOpen: true,
                    text: <FormattedMessage id="app.admin.side-bar.inquiries"
                                            defaultMessage="Inquiries"
                                            description=""/>,
                    menuItems: [
                        {
                            id: "1a",
                            text: <FormattedMessage id="app.admin.side-bar.all-inquiries"
                                                    defaultMessage="All Inquiries"
                                                    description=""/>,
                            link: "/admin/inquiries/viewAll"
                        }
                    ]
                },
                // {
                //     id: 2,
                //     isOpen: false,
                //     text: <FormattedMessage id="app.admin.side-bar.orders"
                //                             defaultMessage="Orders"
                //                             description=""/>,
                //     menuItems: [
                //         {
                //             text: <FormattedMessage id="app.admin.side-bar.all-orders"
                //                                     defaultMessage="All Orders"
                //                                     description=""/>,
                //             link: "/admin/orders/all"
                //         }
                //     ]
                // },
                {
                    id: 3,
                    isOpen: false,
                    text: <FormattedMessage id="app.admin.side-bar.sales"
                                            defaultMessage="Sales"
                                            description=""/>,
                    menuItems: [
                        {
                            id: "3a",

                            text: <FormattedMessage id="app.admin.side-bar.all-sales"
                                                    defaultMessage="All Sales"
                                                    description=""/>,
                            link: "/admin/sales/view"
                        },
                        {
                            id: "3b",

                            text: "注文のキャンセル",
                            link: "/admin/sales/cancelled"
                        }
                    ]
                },
                {
                    id: 8,
                    isOpen: false,
                    text: "出荷明細",
                    menuItems: [
                        {
                            id: "8a",

                            text: "出荷一覧",
                            link: "/admin/production"
                        }
                    ]
                },
                {
                    id: 4,
                    isOpen: false,
                    text: <FormattedMessage id="app.admin.side-bar.users-all"
                                            defaultMessage="Users"
                                            description=""/>,
                    menuItems: [
                        {
                            id: "4a",

                            text: <FormattedMessage id="app.admin.side-bar.all-customers"
                                                    defaultMessage="All Customers"
                                                    description=""/>,
                            link: "/admin/customers/all"
                        },
                        // {
                        //     text: <FormattedMessage id="app.admin.side-bar.add-new-user"
                        //                             defaultMessage="Add New Admin"
                        //                             description=""/>,
                        //     link: "/admin/users/create"
                        // },
                        {
                            id: "4b",

                            text: <FormattedMessage id="app.admin.side-bar.all-users"
                                                    defaultMessage="All Admins"
                                                    description=""/>,
                            link: "/admin/users/all"
                        }

                    ]
                },
                {
                    id: 6,
                    isOpen: false,
                    text: "品質報告",
                    menuItems: [
                        {
                            id: "6a",

                            text: "品質報告一覧",
                            link: "/admin/quality-complaint"
                        }
                    ]
                },
                // {
                //     id: 5,
                //     isOpen: false,
                //     text: <FormattedMessage id="app.admin.side-bar.users"
                //                             defaultMessage="Admin Users"
                //                             description=""/>,
                //     menuItems: [
                //         {
                //             text: <FormattedMessage id="app.admin.side-bar.add-new-user"
                //                                     defaultMessage="Add New Admin"
                //                                     description=""/>,
                //             link: "/admin/users/create"
                //         },
                //         {
                //             text:<FormattedMessage id="app.admin.side-bar.all-users"
                //                                    defaultMessage="All Admins"
                //                                    description=""/>,
                //             link: "/admin/users/all"
                //         }
                //     ]
                // },
                /*{
                    id: 5,
                    isOpen: false,
                    text: <FormattedMessage id="app.admin.side-bar.chats"
                                            defaultMessage="Chats"
                                            description=""/>,
                    menuItems: [
                        {
                            id: "5a",

                            text: <FormattedMessage id="app.admin.side-bar.all-chats"
                                                    defaultMessage="All Chats"
                                                    description=""/>,
                            link: "/admin/chat"
                        }
                    ]
                },*/


                /*{
                    id: 7,
                    isOpen: false,
                    text: <FormattedMessage id="app.admin.side-bar.article"
                                            defaultMessage="Information Articles"
                                            description=""/>,
                    menuItems: [
                        {
                            id: "7a",

                            text: <FormattedMessage id="app.admin.side-bar.create-articles"
                                                    defaultMessage="Add Article"
                                                    description=""/>,
                            link: "/admin/article/new"
                        },
                        {
                            id: "7b",

                            text: <FormattedMessage id="app.admin.side-bar.view-articles"
                                                    defaultMessage="All Articles"
                                                    description=""/>,
                            link: "/admin/article/all"
                        }
                    ]
                },*/

                {
                    id: 9,
                    isOpen: false,
                    text: <FormattedMessage id="app.admin.side-bar.system-config"
                                            defaultMessage="System Configuration"
                                            description=""/>,
                    menuItems: [
                        {
                            id: "9a",

                            text: <FormattedMessage id="app.admin.side-bar.currency-config"
                                                    defaultMessage="Currency Configuration"
                                                    description=""/>,
                            link: "/admin/currency/configuration"
                        }
                    ]
                },


            ]
        };

        this.setOpenMenu = this.setOpenMenu.bind(this);
    }

    setOpenMenu = (menuId) => {
        // console.log(menuId);
        let data = this.state.menus.map((m) => {
            if (m.id === menuId) {
                return {...m, isOpen: true};
            } else {
                return {...m, isOpen: false};
            }
        });
        // console.log(data);
        this.setState({
            menus: data
        });
    };

    componentDidMount() {
        // var coll = document.getElementsByClassName("collapsible");
        // var i;
        //
        // for (i = 0; i < coll.length; i++) {
        //     coll[i].addEventListener("click", function () {
        //         this.classList.toggle("active");
        //         var content = this.nextElementSibling;
        //         if (content.style.display === "block") {
        //             content.style.display = "none";
        //         } else {
        //             content.style.display = "block";
        //         }
        //     });
        // }
        // document.getElementById("1a").click();
        console.log("in mount");
    }

    render() {
        // console.log("CHAT USER COUNT ===>", this.props.onlineChatUsers);
        return (
            <div>
                {/*<button className="collapsible">NavBar</button>*/}

                <div className="content content-responsive">
                    <div className="main-nav-menu" id="main-nav-text">
                        <FormattedMessage id="app.admin.side-bar.main-navigation"
                                          defaultMessage="MAIN NAVIGATION"
                                          description=""/>

                    </div>
                    <div className="link-text-color">
                        {this.state.menus.map((m) => {
                            return <MainMenu
                                id={m.menuItems.id}
                                data={m}
                                key={m.id}
                                onlineChatUsers={this.props.onlineChatUsers}
                                setOpenMenu={this.setOpenMenu}
                            />
                        })}
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/AdminRoot/AdminLayout/Sidebar/SideBar.js